var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
var ProductQuantitySelectorAxb = /** @class */ (function (_super) {
    __extends(ProductQuantitySelectorAxb, _super);
    function ProductQuantitySelectorAxb(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.step = 1;
        _this.min = 0;
        _this.max = null;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        ProductQuantitySelectorAxb.buildFromJson(_this, obj);
        return _this;
    }
    ProductQuantitySelectorAxb.prototype.isQuantityAllowed = function (quantity, options) {
        if (options === undefined || options && options.debug === undefined) {
            options = { debug: true };
        }
        /** Est ce que l'on est plus grand que le max ? **/
        var test_quantity_higher_than_max = (this.max !== null && this.max < quantity);
        if (test_quantity_higher_than_max) {
            if (options.debug) {
                console.warn("MaxQuantity is not null and quantity tryed to add is higher.\n", "File : GroupItem.ts\n", "Object : ProductQuantitySelectorAxb\n", "Function : isQuantityAllowed()");
            }
            return false;
        }
        /** Est ce que l'on est plus petit que le min ? **/
        var test_quantity_lower_than_min = this.min > quantity;
        if (test_quantity_lower_than_min) {
            if (options.debug) {
                console.warn("MinQuantity is higher than quantity.\n", "File : GroupItem.ts\n", "Object : ProductQuantitySelectorAxb\n", "Function : isQuantityAllowed()");
            }
            return false;
        }
        var test_quantity_value;
        if (this.step !== 0) {
            test_quantity_value = (quantity - this.min) % this.step === 0;
        }
        else {
            test_quantity_value = (quantity - this.min) === 0;
        }
        if (!test_quantity_value && options.debug) {
            console.warn("(quantity - this.min) % this.step !== 0\n", "Code : 1040\n", "Values : \n", "\tquantity = " + quantity + "\n", "\tstep = " + this.step + "\n", "\tmin = " + this.min + "\n", "\tmax = " + this.max + "\n", "File : GroupItem.ts\n", "Object : ProductQuantitySelectorAxb\n", "Function : isQuantityAllowed()\n");
        }
        return test_quantity_value;
    };
    ProductQuantitySelectorAxb.prototype.get_next_quantity = function (value) {
        var next_quantity = this.get_next_occurrence(value) * this.step + this.min;
        /** Si on est plus grand que le max **/
        if (this.max !== null && next_quantity > this.max) {
            var max = this.get_max();
            if (max !== null) {
                return max;
            }
        }
        if (next_quantity < this.min) {
            return this.min;
        }
        return next_quantity;
    };
    ProductQuantitySelectorAxb.prototype.get_previous_quantity = function (value) {
        var previous_quantity = this.get_previous_occurrence(value) * this.step + this.min;
        /** Si on est plus grand que le max **/
        if (this.max !== null && previous_quantity > this.max) {
            var max = this.get_max();
            if (max !== null) {
                return max;
            }
        }
        if (previous_quantity < this.min) {
            return this.min;
        }
        return previous_quantity;
    };
    ProductQuantitySelectorAxb.prototype.get_max = function () {
        if (this.max !== null) {
            /** Si le max n'est pas un nombre atteingrable par la formule
             * step*x+min alors on prend le nombre juste avant.
             * **/
            if (this.max % this.step !== 0) {
                return Math.floor(this.max / this.step) * this.step;
            }
            else {
                return this.max;
            }
        }
        return null;
    };
    ProductQuantitySelectorAxb.prototype.get_next_occurrence = function (value) {
        if (value < this.min) {
            return 0;
        }
        var current_occurence = (value - this.min);
        if (this.step !== 0) {
            current_occurence = Math.floor(current_occurence / this.step);
        }
        return current_occurence + 1;
    };
    ProductQuantitySelectorAxb.prototype.get_previous_occurrence = function (value) {
        if (value < this.min) {
            return 0;
        }
        var current_occurence = (value - this.min);
        if (this.step !== 0) {
            current_occurence = Math.round(current_occurence / this.step);
        }
        return current_occurence - 1;
    };
    ProductQuantitySelectorAxb.buildFromJson = function (instance, json) {
        if (typeof json === 'object') {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    ProductQuantitySelectorAxb.prototype.exportToJson = function () {
        var JSONQuantitySelectorAxb = {};
        JSONQuantitySelectorAxb.step = this.step;
        JSONQuantitySelectorAxb.min = this.min;
        if (this.max + "" === "") {
            JSONQuantitySelectorAxb.max = null;
        }
        else {
            JSONQuantitySelectorAxb.max = this.max;
        }
        return JSONQuantitySelectorAxb;
    };
    return ProductQuantitySelectorAxb;
}(Model));
export { ProductQuantitySelectorAxb };
//# sourceMappingURL=ProductQuantitySelectorAxb.js.map